/**
 * Утилита для плавной анимации значений
 * Используется для smooth зума и панорамирования как в Excalidraw
 */
// Easing функции для разных типов анимации
export var easing = {
    // Плавное замедление в конце (default для большинства анимаций)
    easeOutQuad: function (t) { return t * (2 - t); },
    // Плавное ускорение и замедление
    easeInOutQuad: function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },
    // Более выраженное замедление (лучше для зума)
    easeOutCubic: function (t) { return (--t) * t * t + 1; },
    // Линейная анимация
    linear: function (t) { return t; },
};
/**
 * Анимирует значение от start до end
 */
export var animateValue = function (start, end, options) {
    var _a = options.duration, duration = _a === void 0 ? 200 : _a, // По умолчанию 200мс для быстрого отклика
    _b = options.easing, // По умолчанию 200мс для быстрого отклика
    easingFn = _b === void 0 ? easing.easeOutCubic : _b, onUpdate = options.onUpdate, onComplete = options.onComplete;
    var startTime = performance.now();
    var cancelled = false;
    var animationFrameId;
    var animate = function (currentTime) {
        if (cancelled)
            return;
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easingFn(progress);
        var currentValue = start + (end - start) * easedProgress;
        onUpdate(currentValue);
        if (progress < 1) {
            animationFrameId = requestAnimationFrame(animate);
        }
        else {
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        }
    };
    animationFrameId = requestAnimationFrame(animate);
    // Возвращаем функцию для отмены анимации
    return function () {
        cancelled = true;
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
        }
    };
};
/**
 * Анимирует координаты от (startX, startY) до (endX, endY)
 */
export var animateCoordinates = function (startX, startY, endX, endY, options) {
    var _a = options.duration, duration = _a === void 0 ? 200 : _a, _b = options.easing, easingFn = _b === void 0 ? easing.easeOutCubic : _b, onUpdate = options.onUpdate, onComplete = options.onComplete;
    var startTime = performance.now();
    var cancelled = false;
    var animationFrameId;
    var animate = function (currentTime) {
        if (cancelled)
            return;
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easingFn(progress);
        var currentX = startX + (endX - startX) * easedProgress;
        var currentY = startY + (endY - startY) * easedProgress;
        onUpdate(currentX, currentY);
        if (progress < 1) {
            animationFrameId = requestAnimationFrame(animate);
        }
        else {
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        }
    };
    animationFrameId = requestAnimationFrame(animate);
    return function () {
        cancelled = true;
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
        }
    };
};
/**
 * Менеджер для отмены предыдущих анимаций
 * Используется для предотвращения множественных одновременных анимаций
 */
var AnimationManager = /** @class */ (function () {
    function AnimationManager() {
        this.cancelFunctions = new Map();
    }
    /**
     * Запускает новую анимацию, отменяя предыдущую с тем же ключом
     */
    AnimationManager.prototype.start = function (key, cancelFn) {
        this.cancel(key);
        this.cancelFunctions.set(key, cancelFn);
    };
    /**
     * Отменяет анимацию по ключу
     */
    AnimationManager.prototype.cancel = function (key) {
        var cancelFn = this.cancelFunctions.get(key);
        if (cancelFn) {
            cancelFn();
            this.cancelFunctions.delete(key);
        }
    };
    /**
     * Отменяет все активные анимации
     */
    AnimationManager.prototype.cancelAll = function () {
        this.cancelFunctions.forEach(function (cancelFn) { return cancelFn(); });
        this.cancelFunctions.clear();
    };
    return AnimationManager;
}());
export { AnimationManager };
